import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Button, Form, FormGroup, Label, Input, FormText } from "reactstrap";
import { Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

// modal

export default function Processingmodal(props) {
  const navigate = useNavigate();
  return (
    <>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="BCtwalletmod"
      >
        <Modal.Body>
          <div className="trassaction_mod_inner position-relative">
            <a
              href="javascript:void(0)"
              className="close-btn"
              onClick={props.onHide}
            >
              <span className="me-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="51"
                  height="50"
                  viewBox="0 0 51 50"
                  fill="none"
                >
                  <path
                    d="M40.0417 10.2084C31.9167 2.08337 18.5834 2.08337 10.4584 10.2084C2.33337 18.3334 2.33337 31.6667 10.4584 39.7917C18.5834 47.9167 31.7084 47.9167 39.8334 39.7917C47.9584 31.6667 48.1667 18.3334 40.0417 10.2084ZM31.0834 33.75L25.25 27.9167L19.4167 33.75L16.5 30.8334L22.3334 25L16.5 19.1667L19.4167 16.25L25.25 22.0834L31.0834 16.25L34 19.1667L28.1667 25L34 30.8334L31.0834 33.75Z"
                    fill="black"
                  />
                </svg>
              </span>
            </a>
            <h4 className="m-0">{props.title}</h4>

            <div className="processing_data text-center">
               
               <div className="images_aniamtion">
                  <img src="/images/processani.gif" alt="" className="img-fluid"/>
               </div>
                <h4>Congratulations</h4>
                <p>Your request has been submitted successfully</p>
              <Button
                className="btn_sign_in w-100 btn_theme mt-4"
                onClick={() => navigate("/")}
              >
                Home
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
